/**
 * a videoplayer, that selects and plays html5 video depending on its pixelsize and the device-pixel-ratio
 */
var VideoPlayer = /** @class */ (function () {
    /**
     * construct.
     */
    function VideoPlayer(el) {
        this.ready = false;
        this.videoId = -1;
        this.sources = [];
        this.maxDevicePixelRatio = 1.25;
        this.currentVideoRatio = 56.25;
        this.videoHolder = el;
        var firstChild = el.children[0];
        if (firstChild.tagName === 'VIDEO') {
            this.video = firstChild;
        }
    }
    /**
     * initial setup
     */
    VideoPlayer.prototype.init = function () {
        if (!this.video) {
            console.error('please check your markup: <video> must be the first child');
            return;
        }
        // collect data from element
        var vData = this.video.dataset.sources;
        if (!vData || vData.length === 0) {
            console.error('no video sources given');
            return;
        }
        this.sources = JSON.parse(vData);
        // sort videos from smallest to largest
        this.sources.sort(function (a, b) {
            return a.width - b.width;
        });
        // append a source element
        this.videoSrc = document.createElement('source');
        this.videoSrc.setAttribute('type', 'video/mp4');
        this.video.appendChild(this.videoSrc);
        // all good, let's play a video
        this.ready = true;
        this.resize();
        this.video.classList.add('active');
        window.addEventListener('resize', this.resize.bind(this));
    };
    /**
     * collect some functions under one hood
     */
    VideoPlayer.prototype.resize = function () {
        var _this = this;
        // this.fitVideoInContainer()
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                _this.selectVideo();
            });
        });
    };
    /**
     * fit the video in it's surrounding container
     */
    VideoPlayer.prototype.fitVideoInContainer = function () {
        var holderWidth = this.videoHolder.offsetWidth;
        var holderHeight = this.videoHolder.offsetHeight;
        var holderRatio = holderHeight / holderWidth * 100;
        var videoWidth = '100%';
        var videoHeight = 'auto';
        var videoLeft = '0px';
        var videoTop = '0px';
        // Landscape mode
        if (this.currentVideoRatio < 100) {
            if (holderRatio > this.currentVideoRatio) {
                // stretch the width
                var width = holderHeight / (this.currentVideoRatio / 100);
                videoWidth = "".concat(width.toFixed(2), "px");
                videoLeft = "".concat(-(width - holderWidth) / 2, "px");
                videoHeight = '100%';
                videoTop = '0';
            }
            else {
                // stretch the height
                var height = holderWidth / (this.currentVideoRatio / 100);
                videoHeight = "".concat(height.toFixed(2), "px");
                videoTop = "".concat(-(height - holderHeight) / 2, "px");
                videoWidth = '100%';
                videoLeft = '0';
            }
        }
        else {
            // Portrait mode
            if (holderRatio > this.currentVideoRatio) {
                // stretch the width
                var width = holderHeight / (this.currentVideoRatio / 100);
                videoWidth = "".concat(width.toFixed(2), "px");
                videoLeft = "".concat(-(width - holderWidth) / 2, "px");
                videoHeight = '100%';
                videoTop = '0';
            }
            else {
                // stretch the height
                var height = holderWidth * (this.currentVideoRatio / 100);
                videoHeight = "".concat(height.toFixed(2), "px");
                videoTop = "".concat(-(height - holderHeight) / 2, "px");
                videoWidth = '100%';
                videoLeft = '0';
            }
        }
        // set styles
        this.video.style.width = videoWidth;
        this.video.style.height = videoHeight;
        this.video.style.left = videoLeft;
        this.video.style.top = videoTop;
    };
    /**
     * select a video and load and play it (if necessary)
     * @returns
     */
    VideoPlayer.prototype.selectVideo = function () {
        if (!this.ready) {
            return;
        }
        var newVideoId = this.getBestFittingVideo();
        // if our new calculated one different to the current one: Change size!
        if (newVideoId !== this.videoId) {
            this.videoId = newVideoId;
            // pause and remember position
            this.video.pause();
            var currentTime = this.video.currentTime;
            // prepare new source and refit video
            var currentVideo = this.sources[this.videoId];
            this.currentVideoRatio = (currentVideo.height / currentVideo.width) * 100;
            // this.fitVideoInContainer()
            // change source and load
            this.videoSrc.setAttribute('src', this.sources[this.videoId].url);
            this.video.load();
            // reset playposition and play
            this.video.currentTime = currentTime;
            this.video.play();
        }
    };
    /**
     * loop through all video sizes and find the one most suitable for our video and device pixels
     * @returns number
     */
    VideoPlayer.prototype.getBestFittingVideo = function () {
        // select the ratio and multiply it with the size of the video element
        var dpRatio = (window.devicePixelRatio > this.maxDevicePixelRatio) ? this.maxDevicePixelRatio : window.devicePixelRatio;
        var vWidth = this.videoHolder.offsetWidth * dpRatio;
        var vHeight = this.videoHolder.offsetHeight * dpRatio;
        var landscape = vWidth > vHeight;
        // store videos that are better than nothing
        var fallbackVideoId = null;
        // loop through all sources to find the best fitting one
        for (var vId in this.sources) {
            var src = this.sources[vId];
            // look for landscape videos only in landscape env or portrait only in portrait env
            if ((landscape && src.width > src.height) ||
                (!landscape && src.width < src.height)) {
                // if this src is bigger than the video itself select it
                if (src.width > vWidth && src.height > vHeight) {
                    return parseInt(vId);
                }
                else {
                    // if we have no fallback yet, just take it
                    if (fallbackVideoId === null) {
                        fallbackVideoId = parseInt(vId);
                    }
                    else {
                        // otherwise check if this fits better.
                        var fallbackSrc = this.sources[fallbackVideoId];
                        if (src.width > fallbackSrc.width && src.height > fallbackSrc.height) {
                            fallbackVideoId = parseInt(vId);
                        }
                    }
                }
            }
        }
        // none found? just take the largest one.
        return fallbackVideoId || this.sources.length - 1;
    };
    /**
     * set the maximum device pixel ratio, that we want to acknowledge
     * @param ratio
     */
    VideoPlayer.prototype.setMaxDevicePixelRatio = function (ratio) {
        this.maxDevicePixelRatio = ratio;
    };
    return VideoPlayer;
}());
/**
 * Export
 */
export default VideoPlayer;
